import * as Yup from 'yup';
export const AllotingForm = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    mobile: Yup.string().required('Phone number is required.'),
});
export const AffiliateForm = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    mobile_number: Yup.string().required('Phone number is required.'),
});
export const SlotAdd = Yup.object().shape({
    capacity: Yup.string().required('Capacity is required'),
    sessionId: Yup.string().required('Session is required'),
    slot_name: Yup.string().required('Slot Name is required'),
    slot_interval: Yup.string().required('Slot Interval is required'),
});
export const eventDiscount = Yup.object().shape({
    coupon_name: Yup.string().trim('No leading or trailing spaces allowed').max(25, 'Discount Name must be 25 or less than 26 characters').required('Discount Name is required'),
    percentage: Yup.number().min(0, 'Discount Value must be greater than 0').when('is_points', {
        is: 'false',
        then: (schema) => schema.max(100, 'Discount Value must be 100 or less for percent type'),
        otherwise: (schema) => schema.test(
            'max-digits',
            'Discount Value must be 6 digits or fewer for fixed type',
            (value) => !value || String(value).length <= 6
        )
    }),
    usage_limit: Yup.string().required('Discount Usage Limit is required')
});